import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import moment from "moment";
import { firstLetterShouldCapital,formatDateMoment,capitalizeWords } from "../../../utils/utils";
import { selectCurrentCycle,selectFollowCycle } from "../../slices/common";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";

const ManufacturingLabelPrint = React.forwardRef(({isVisible=false, printData }, ref) => {
  const {
    printPatientInfo,
   printCount = 1,
    // printSingleBag,
    patientMedicalInfo = {},
  } = printData || {};
  const currentCycle = isVisible ? useSelector(selectFollowCycle) : useSelector(selectCurrentCycle)

  const patientInfo = printPatientInfo?.patient_information || {};
  const batchInfo = printPatientInfo || {};
  const patientName = patientInfo.name || "";
  const qrValue = `${window.location.origin}/lsm/qr/${currentCycle?.qr_code_generation_id}`;
  const date = (d) => (d ? moment(d).format("DD/MM/YYYY") : "-");
   //const brand_name = topLevel?.brand_name;
   //const org_name = topLevel?.brand_name;
  return (
    <div ref={ref} className="font-sans">
      {Array.from({ length: printCount }).map((_, index) => {

        return (
          <div
            key={index}
            style={{
              width: "104mm",
              height: "104mm",
              padding: "5px",
              boxSizing: "border-box",
              pageBreakAfter: "always",
              fontSize: "12px",
              display: "flex",
              flexDirection: "column",
              borderRadius:"5px",
              fontWeight: 700
            }}
          >
            {/* ================= OUTLINED BOX (LEFT INFO + QR) ================= */}
            <Box
              sx={{
                padding: "4px",
                display: "flex",
                justifyContent: "space-between",
                marginTop: isVisible ? "241px":"196px",
                marginLeft: isVisible ? "125px" : "100px",
              }}
            >
              {/* Left Column */}
              <div className="text-sm leading-relaxed space-y-0.3">
                <p style={{marginTop: isVisible ?'0px':'1px',marginLeft: isVisible ?'12px':'9px'}}>
                   {patientInfo.patient_id || "-"}
                </p>
                <p style={{marginTop: isVisible ?'1px':'0px',marginLeft: '38px'}}>
                  {firstLetterShouldCapital(capitalizeWords(patientName))}
                </p>
                 <p style={{marginTop: isVisible ?'1px':'-2px',marginLeft:isVisible ? '28px':'25px'}}>
                  {patientMedicalInfo["Date of Birth"] || date(patientInfo.dob)}
                </p>
                 <p style={{marginTop: isVisible ?'3px':'-2px',marginLeft:isVisible ?  '84px':'81px'}}>
                  {formatDateMoment(currentCycle?.mfg_at) || ""}
                </p>
                <p style={{marginTop: isVisible ?'1px':'-1px',marginLeft: '15px'}}> {date(batchInfo.expiry_date)}
                </p>
                 <p style={{marginTop: isVisible ?'2px':'-1px',marginLeft: isVisible ? '42px':'40px'}}>{currentCycle?.batch_no || ""}
                </p>
              </div>

              {/* Right Column → QR */}
              <div className={`flex flex-col items-center justify-between  mt-4 ${isVisible ? 'ml-16': 'ml-8'}`}>
                <QRCodeCanvas value={qrValue} size={isVisible ? 100: 80} />
              </div>
            </Box>
          </div>
        );
      })}
    </div>
  );
});

ManufacturingLabelPrint.displayName = "ManufacturingLabelPrint";

export default ManufacturingLabelPrint;
